import React from 'react'

const DeletedIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 6.125C7.57475 6.125 8.75 4.94975 8.75 3.5C8.75 2.05025 7.57475 0.875 6.125 0.875C4.67525 0.875 3.5 2.05025 3.5 3.5C3.5 4.94975 4.67525 6.125 6.125 6.125Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.29167 8.23745C6.91658 8.15616 6.52575 8.11328 6.125 8.11328C3.22525 8.11328 0.875 10.3567 0.875 13.1246H7.29167"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 9.22656L9.625 12.5675"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 9.22656L13.125 12.5675"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DeletedIcon
